import React from 'react';
import GeneralLayout from '../layouts/GeneralLayout';
import { LayoutTypes } from '../types';
import ContactUs from '../components/ContactUs';
import { getMainMenuItems } from '../utils/nav-menu';

const ContactUsPage = () => {

  const baseUrl = process.env.REACT_APP_BUYING_HOUSE_DOMAIN_BASE_URL;
  const baseParentUrl = process.env.REACT_APP_SOPHINEX_DOMAIN_BASE_URL;
  const navOptions = {
    ...getMainMenuItems(LayoutTypes.main),
    baseUrl,
    baseParentUrl,
    isBgDark: false,
    isSideBgDark: false
  };

  return (
    <GeneralLayout {...navOptions}>
      <ContactUs></ContactUs>
    </GeneralLayout>
  );
}

export default ContactUsPage;
